import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ListService {


    getNextCyclicIndex(currentIndex: number, step: number, totalItems: number): number {
        const x = currentIndex + step;
        // negative modulo fix (x % n + n) % n
        return ((x % totalItems) + totalItems) % totalItems;
    }
}
